import { Card, CardContent } from '@cortex/web-design-system/components/ui/Card';

/**
 * /projects 読み込み中のスケルトン UI。Summary Cards 3 枚 + テーブル 5 行分のプレースホルダ。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain UX
 * @graph-business プロジェクト管理ページのローディング表示。サマリーカードとテーブル行をプレースホルダで描画
 * @graph-connects none
 */
export function ProjectsLoadingSkeleton() {
  return (
    <>
      <div
        data-testid="projects-skeleton-summary"
        className="grid grid-cols-1 md:grid-cols-3 gap-6"
      >
        {[1, 2, 3].map((i) => (
          <Card key={i} data-testid="projects-skeleton-summary-card">
            <CardContent>
              <div className="text-center py-4">
                <div className="h-4 w-24 mx-auto rounded bg-[var(--color-bg-elevated)] animate-pulse mb-2" />
                <div className="h-12 w-16 mx-auto rounded bg-[var(--color-bg-elevated)] animate-pulse" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
      <Card data-testid="projects-skeleton-table">
        <div className="px-6 pt-5 pb-4">
          <div className="h-5 w-32 rounded bg-[var(--color-bg-elevated)] animate-pulse" />
        </div>
        <CardContent>
          <div className="space-y-0">
            {[1, 2, 3, 4, 5].map((i) => (
              <div
                key={i}
                data-testid="projects-skeleton-table-row"
                className="flex items-center gap-4 py-3 px-4 border-b border-[var(--color-border)]"
              >
                <div className="h-4 w-20 rounded bg-[var(--color-bg-elevated)] animate-pulse" />
                <div className="h-4 w-48 flex-1 rounded bg-[var(--color-bg-elevated)] animate-pulse" />
                <div className="h-4 w-16 rounded bg-[var(--color-bg-elevated)] animate-pulse" />
                <div className="h-4 w-16 rounded bg-[var(--color-bg-elevated)] animate-pulse" />
                <div className="h-2 w-24 rounded-full bg-[var(--color-bg-elevated)] animate-pulse" />
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </>
  );
}
